@if (hasProduction || hasProductionGroup) {
  <div class="mx-12">
    @if (hasProduction) {
      <table class="no-space w-full" cellspacing="0" cellpadding="0">
        @if (quantitySkfs.length === 0) {
          <tr class="grid h-[50px] grid-flow-row grid-cols-4">
            <th class="col-span-2"><strong>Production</strong></th>
            <th><strong>Quantity</strong></th>
            <th><strong>Weekly Total</strong></th>
          </tr>
        }
        @for (row of quantitySkfs; track row) {
          <tr class="grid grid-flow-row grid-cols-4 items-center pb-2">
            <ng-container>
              <td class="col-span-2 w-full pr-[60px]">
                <read-only-text [hasLeftSpacing]="false" [shouldTranslate]="true" [val]="row.description" />
              </td>
              <td class="w-full">
                <numeric-input-field [control]="row.value" />
              </td>
              <td class="w-full">
                <read-only-field [val]="row.weDateTotal" />
              </td>
            </ng-container>
          </tr>
        }
      </table>
    }
    <br />
    <div class="w-full items-center justify-center"></div>
    <div class="flex flex-wrap">
      @for (text of textSkfs; track text) {
        <div class="w-full">
          <grid-switch [options]="text.selectOptions" [value]="text.value" [label]="text.description" [type]="text.type" />
        </div>
      }
    </div>
    @if (hasProductionGroup) {
      <div class="mb-8 mt-4">
        <mat-accordion>
          @for (group of timeSheet.currentProductionGroups; track group) {
            <div class="mb-4 flex">
              <mat-expansion-panel hideToggle class="w-full" [expanded]="$last">
                <mat-expansion-panel-header class="w-full whitespace-nowrap">
                  <mat-panel-title>Stop {{ $index + 1 }} </mat-panel-title>
                  @if (isTimesheetApproved) {
                    <mat-panel-description class="font-semibold">
                      Timesheet Approved - Please contact your supervisor if any changes need to be made.
                    </mat-panel-description>
                  }
                </mat-expansion-panel-header>
                <div class="grid grid-flow-row grid-cols-3 items-end gap-x-4 gap-y-6">
                  @for (skf of group.entities; track skf) {
                    <grid-switch
                      [class.col-span-3]="skf.type === 'TEXT'"
                      [options]="skf.selectOptions"
                      [value]="skf.value"
                      [label]="skf.description"
                      [type]="skf.type"
                    />
                  }
                </div>
                <div class="w-full text-end">
                  <button mat-raised-button color="warn" [disabled]="isTimesheetApproved" (click)="deleteGroup(group)">
                    <mat-icon>delete</mat-icon>
                    Delete Stop {{ $index + 1 }}
                  </button>
                </div>
              </mat-expansion-panel>
            </div>
          }
        </mat-accordion>
        <button mat-raised-button color="primary" [disabled]="isTimesheetApproved" (click)="addGroup()">
          <mat-icon>add</mat-icon>
          Add Stop
        </button>
      </div>
    }
  </div>
} @else {
  <div class="no-space flex h-[80vh] w-full items-center justify-center">This contract does not have any production.</div>
}
